import { useState } from 'react';
import { StripeAddressElementChangeEvent } from '@stripe/stripe-js';
import env from '@frontend/env';
import { useTranslation } from '@frontend/i18n';
import { IdIcon, Stepper } from '@frontend/design-system';
import { Recaptcha } from '../../atoms';
import { StripeBillingDetails } from '../../stripe-components';
import { useStripeStepper } from '../stripe-stepper-context';

interface StripeBillingDetailsStepProps {
  onSubmit: () => void;
}

export const StripeBillingDetailsStep = ({ onSubmit }: StripeBillingDetailsStepProps) => {
  const { t } = useTranslation('weave-pay');

  const {
    paymentRequest,
    setPaymentRequest,
    portalStepperSettings: { oneTimeRequest, skipCaptcha },
    setCaptchaToken,
  } = useStripeStepper();

  const [stepIsValid, setStepIsValid] = useState(false);

  const handleAddressChange = (event: StripeAddressElementChangeEvent) => {
    if (event.complete) {
      const cardholderName = event.value.name;
      setPaymentRequest({ ...paymentRequest, cardholderName });
      setStepIsValid(true);
    }
  };

  return (
    <>
      <Stepper.Title icon={<IdIcon />}>{t('Enter Billing Information')}</Stepper.Title>
      <Stepper.Content>
        <StripeBillingDetails onAddressChange={handleAddressChange} />
      </Stepper.Content>
      <Stepper.ButtonBarAlternate>
        {!oneTimeRequest && !skipCaptcha && (
          <Stepper.ButtonAlternate position='tertiary' type='none'>
            <Recaptcha
              onChange={setCaptchaToken}
              recaptchaKey={
                env.PAY_BACKEND_API.includes('weavedev') ? env.PAY_CAPTCHAV2_TEST_SITE_KEY : env.PAY_CAPTCHAV2_SITE_KEY
              }
            />
          </Stepper.ButtonAlternate>
        )}
        <Stepper.ButtonAlternate disabled={!stepIsValid} onClick={onSubmit} type='next' position='primary'>
          {t('Submit')}
        </Stepper.ButtonAlternate>
      </Stepper.ButtonBarAlternate>
    </>
  );
};
